import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';
import { UserCreateEdit } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private pathApi = this.config.setting['pathApi'] + "user/";

  constructor(private http: HttpClient, private config: AppConfig,
  ) { }

  save(obj: UserCreateEdit): Observable<any> {
    return this.http.post(`${this.pathApi}save`, obj);
  }
  getByGuid(id: any): Observable<any> {
    return this.http.get(`${this.pathApi}getByGuid/` + id);
  }
  delete(id: any): Observable<any> {
    return this.http.get(`${this.pathApi}delete/` + id);
  }
  resetPassword(email: string): Observable<any> {
    return this.http.get(`${this.pathApi}resetPassword/` + email);
  }
  changePassword(obj : any): Observable<any> {
    return this.http.post(`${this.pathApi}changePassword/`, obj);
  }

  //stari
  login(loginForm: any, paramMap: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
    return this.http.post<HttpResponse<any>>(this.pathApi+'auth/login?' + paramMap, loginForm, { withCredentials: true });
  }

  register(registerForm: any): Observable<any> {
    return this.http.post(this.pathApi+'auth/register', registerForm, { withCredentials: true });
  }

  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  }
  deactivate(guid: any): Observable<any> {
    return this.http.post(`${this.pathApi}deactivate`, guid);
  }
  activate(guid: any): Observable<any> {
    return this.http.post(`${this.pathApi}activate`, guid);
  }

  changeUserStatus(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}changeUserStatus`, obj);
  }

}
